import React from 'react';
import UserDaysStatTable1 from './UserDaysStatTable1';
import groupsSearchItem from '../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';

const GroupsSearchItem = groupsSearchItem(UserDaysStatTable1);

export default props => (
  <GroupsSearchItem
    {...props}
    groupName="userDaysStatTable1"
    listReduceName="userDaysStatModule.lists.userDaysStatList"
  />
);



// WEBPACK FOOTER //
// ./src/components/UserDaysStat/UserDaysStatTables/UserDaysStatTable1/index.js